<template>
  <div>
    <!-- 需要移箱商品 -->
    <el-dialog :title="$t('message.goodsNeedToBeMoved')" :close-on-click-modal="false"
      :visible.sync="$parent.goodsNeedToBeMovedDialogVisible" width="1708px" center>
      <div class="content">
        <div class="table">
          <ol>
            <!--  番号-->
            <li class="flex05">
              {{ $t("message.mash") }}
            </li>
            <!-- 订单号 -->
            <li class="flex15">{{ $t("message.orderNumber") }}</li>

            <!--写真-->
            <li>
              {{ $t("message.photo") }}
            </li>
            <!-- 商品属性 -->
            <li class="flex15">{{ $t("message.commodityAttribute") }}</li>
            <!-- 商品费用 -->
            <li>{{ $t("message.forGoods") }}</li>
            <!--本箱装货数  -->
            <li class="flex2">{{ $t("message.quantityOfCargoInThisCase") }}</li>
            <!-- 其他箱已装箱数 -->
            <li class="flex15">{{ $t("message.numberOfOtherBoxesPacked") }}</li>
            <!--移箱数量  -->
            <li class="flex2">
              {{ $t("message.containerTransferQuantity") }}
            </li>
          </ol>

          <!-- 订单详情 -->
          <ul v-for="(item, index) in list" :key="index">
            <!--   番号-->
            <li class="flex05">
              {{ item.sorting }}
            </li>
            <!-- 订单号 -->
            <li class="flex15">
              <div>
                <p>{{ item.order_sn }}</p>
                <p>{{ item.realname }}</p>
              </div>
            </li>

            <!--照片-->
            <li>
              <div>
                <div class="img">
                  <el-popover placement="right" width="300" trigger="hover">
                    <img :src="item.pic" alt="" style="width: 300px; height: 300px" />
                    <a :href="`https://detail.1688.com/offer/${item.goods_id}.html`" target="_blank" slot="reference">
                      <img :src="item.pic" alt="" style="width: 60px; height: 60px" />
                    </a>
                  </el-popover>
                </div>
              </div>
            </li>
            <!-- 商品属性 -->
            <li class="flex15">
              <div class="attribute">
                <el-tooltip placement="bottom">
                  <div slot="content">
                    <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex"
                      style="margin-bottom: 5px">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                  <div>
                    <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                </el-tooltip>
              </div>
            </li>
            <!-- 价格.元 -->
            <li>
              <div>
                <p>{{ $t("message.price") }}:{{ item.confirm_price }}</p>
                <p>{{ $t("message.freight") }}:{{ item.confirm_freight }}</p>
              </div>
            </li>
            <!--本箱装货数  -->
            <li class="flex2">
              <div class="purchase">
                <div class="row" v-for="(purchase, purchaseIndex) in item.purchase" :key="purchaseIndex">
                  <span>
                    JY{{ purchaseIndex + 1 }}:{{ purchase.purchase_no }}</span>
                  <!-- 临时库位 -->
                  <span>{{ $t("message.temporaryStorageLocation") }}:{{
                    purchase.order_box_detail_num
                  }}</span>
                </div>
              </div>
            </li>
            <!-- 其他箱已装箱数 -->
            <li class="flex15">{{ item.order_detail_other_box_num }}</li>
            <!--移箱数量  -->
            <li class="flex2">
              <div class="purchase">
                <div class="row" v-for="(purchase, purchaseIndex) in item.purchase" :key="purchaseIndex">
                  <span>
                    JY{{ purchaseIndex + 1 }}:{{ purchase.purchase_no }}</span>
                  <!-- 临时库位 -->
                  <span class="input">
                    <el-input v-model="purchase.num" size="small" type="number" onfocus="this.select()"
                      onkeyup.native="value=value.replace(/^(0+)|[^\d]+/g,'')"
                      @input="maxNum(index, purchaseIndex, purchase)"></el-input></span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!-- 箱子列表 -->
      <div class="box">
        <div class="box-title">
          {{ $t("message.theCurrentOrderIsInBox") }}
        </div>
        <div class="box-list">
          <div class="item" v-for="item in boxList" :key="item.id">
            <div class="item-box">
              <el-radio v-model="id" :label="item.id"> </el-radio>
              <div class="item-content">
                <div class="remark">
                  <p class="text-one">
                    NO{{ item.box_no }}：{{ item.p_remark }}
                  </p>
                </div>
                <div class="NO">{{ item.weight }}kg_{{ item.attr }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="$parent.goodsNeedToBeMovedDialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 确认移箱 -->
        <el-button type="primary" @click="moveOut">{{
          $t("message.confirmationOfBoxMoving")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    order_sn: { type: String },
    list: { type: Array },
  },
  data() {
    return {
      num: "",
      boxList: [],
      id: "",
    };
  },
  created() {
    this.getBoxList();
  },
  methods: {
    // 移箱
    moveOut() {
      let datas = {
        box_id: this.id,
        list: [],
      };
      this.list.forEach((item) => {
        item.purchase.forEach((items) => {
          datas.list.push({
            order_box_detail_id: items.order_box_detail_id,
            num: items.num,
          });
        });
      });
      if (datas.box_id == "") return this.$message.error("未选择要移进的箱子");
      if (!datas.list.every((item) => item.num && item.num != 0))
        return this.$message.error("移箱数未填或者不能为0");

      this.$api.inspectionApi.moveOut(datas).then((res) => {
        this.$message.success(res.msg);
        this.$parent.moveOutSuccess();
      });
    },
    // 获取箱子列表
    getBoxList() {
      let datas = {
        status: 1,
        order_sn: this.order_sn,
      };
      this.$api.inspectionApi.boxList(datas).then((res) => {
        this.boxList = res.data;
        this.$forceUpdate();
      });
    },
    // 最大值
    maxNum(i, index, item) {
      if (item.num > item.order_box_detail_num) {
        this.list[i].purchase[index].num = item.order_box_detail_num;
        this.$message.error("移箱数不能大于装箱数");
        this.$forceUpdate();
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;

  .table {
    background: #f8f8f8;
    border-radius: 8px;
    padding: 24px;

    li {
      margin-right: 20px;

      &:nth-last-child(1) {
        margin: 0;
      }
    }

    ul {
      padding: 30px 0;
    }

    .flex05 {
      flex: 0.5;
      position: relative;

      a {
        position: absolute;
        right: 0;
        top: 0;
        height: 20px;
        width: 20px;
        background-color: #f56c6c;
        border-radius: 50%;
        line-height: 20px;
        text-align: center;
        color: #fff;
      }

      label {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .flex15 {
      flex: 1.5;
    }

    .flex2 {
      flex: 3;

      /deep/ .el-textarea__inner {
        height: 40px;
        padding: 0 2px;
        line-height: 18px;
      }
    }

    .template {
      width: 100%;
      text-align: left;
    }

    .purchase {
      width: 100%;

      .row {
        display: flex;
        justify-content: space-between;
        line-height: 32px;

        .input {
          width: 88px;
          margin-right: 24px;
        }
      }
    }
  }
}

.box {
  border-radius: 8px;
  margin: 24px 15px 0;

  .box-title {
    text-align: center;
    margin: 48px 0 24px;
    font-size: 18px;
  }

  .box-list {
    padding: 0 40px;
    background-color: #e8e8e8;
    display: flex;
    flex-wrap: wrap;
    border-radius: 8px;

    .item {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 288px;
      border-right: 1px solid #edeff4;
      border-bottom: 1px solid #edeff4;
      padding: 20px 0;

      .item-box {
        display: flex;
        justify-content: center;
        align-items: center;

        /deep/.el-radio__input {
          transform: scale(1.5);
        }

        /deep/ .el-radio__label {
          display: none;
        }

        .el-checkbox {
          margin-right: 20px;
        }

        .item-content {
          padding: 15px;
          border: 1px solid #edeff4;
          border-radius: 4px;
          background-color: #fff;
          width: 178px;
          cursor: pointer;

          .remark {
            margin-bottom: 14px;
          }

          .NO {
            color: #999;
          }
        }
      }
    }
  }
}
</style>